import React, { useState, useEffect } from "react";
import {
    Form,
    Input,
    FormInstance,
    Cascader,
    TreeSelect,
    Spin,
    Space,
    Button,
    Row,
    Col,
    Upload,
    notification, Select, Table, Image, Radio, Tooltip, Tag,
    InputNumber
} from "antd";
import { InfoCircleOutlined, PlusOutlined } from '@ant-design/icons';
import {
    deleteTemplateMacTimeMachine, addTemplateMacTimeMachine, getTemplateMacTimeMachine
} from "../../../axios/api.device"

import { useTranslation } from "react-i18next";
import i18n from "@src/locales";
import { UploadChangeParam, UploadFile } from "antd/es/upload";

const { Item } = Form;
interface propsModel {
    templateId: string,
    platform: string,
    templateTab: any,
    updateTemplate: () => void,
}

export const TemplateContentMacTimeMachine = (props: propsModel) => {
    const { templateId, platform, templateTab, updateTemplate } = props;
    const [showTable, setShowTable] = useState<number>(0);
    const [dataForm] = Form.useForm();
    const [isUpload, setIsUpload] = useState<boolean>(false);
    const [imageUrl, setImageUrl] = useState<any>('');
    const [isAdd, setIsAdd] = useState<boolean>(false);
    const { t } = useTranslation();

    var addClick = () => {
        setShowTable(2)
    }
    useEffect(() => {
        getDataInfo()
    }, [])
    const getDataInfo = () => {
        getTemplateMacTimeMachine(templateId).then((res) => {
            if (res && res != null && res.backupDestURL) {
                setShowTable(2)
                setIsAdd(false);
                dataForm?.setFieldsValue(res);
            } else {
                setShowTable(1)
                setIsAdd(true);
            }
        })
    }

    const addTemplateClick = () => {
        dataForm?.validateFields().then(
            (res) => {
                var req = {} as any;
                console.log(res);
                addTemplateMacTimeMachine(templateId, res).then(() => {
                    updateTemplate();
                    notification.success({ message: t("成功") });
                    getDataInfo();
                })
            })
    }
    const deleteTemplateClick = () => {
        dataForm.validateFields().then(() => {
            deleteTemplateMacTimeMachine(templateId).then(() => {
                updateTemplate();
                notification.success({ message: t("成功") });
                dataForm.resetFields();
                getDataInfo();
            })
        })

    }

    return (<>
        <div>
            <Row style={{ margin: "32px 16px 8px 50px", fontSize: "16px" }}>
                <Col className="templateTitle"> {t("时间机器")}</Col>
            </Row>
            <Row><div className="dividerStyle"></div></Row>
            <Row style={{ margin: "16px 16px 16px 0px" }}>
                {showTable == 1 && (

                    <div>
                        <p style={{ margin: "32px 16px 8px 50px", fontSize: "14px" }}>
                            {t("设置Mac时间机器")}</p>
                        <div style={{ margin: "32px 16px 8px 50px", fontSize: "16px" }}>
                            <Button onClick={() => { addClick(); }} type="primary">
                                <PlusOutlined /> {t("添加规则")}
                            </Button>
                        </div>
                    </div>
                )}
                {showTable == 2 && (
                    <>
                        <Form
                            style={{ width: "90%", marginTop: 36 }}
                            layout="horizontal"
                            form={dataForm}
                            labelCol={{ span: 6 }}
                            wrapperCol={{ span: 14 }}
                            initialValues={{ backupAllVolumes: false,backupSkipSys: true, autoBackup: false,
                                mobileBackups: false, backupSizeMB: 0, basePaths: [], skipPaths: []
                              }}
                        >
                                    <Item
                                        label={t("备份地址")}
                                        name="backupDestURL"
                                        rules={[{ required: true }]}
                                        extra={t("如 afp://server.company.com/backups/")}
                                    >
                                        <Input></Input>
                                    </Item>
                                    <Item
                                        label={t("备份所有宗卷")}
                                        name="backupAllVolumes"
                                        extra={t("默认只备份启动宗卷")}
                                    >
                                        <Select style={{width:"50%"}}>
                                            <Select.Option value={true}>{t("是")}</Select.Option>
                                            <Select.Option value={false}>{t("否")}</Select.Option>
                                        </Select>
                                    </Item>
                                    <Item
                                        label={t("备份系统文件")}
                                        name="backupSkipSys"
                                        extra={t("默认跳过备份系统文件")}
                                    >
                                        <Select style={{width:"50%"}}>
                                            <Select.Option value={true}>{t("否")}</Select.Option>
                                            <Select.Option value={false}>{t("是")}</Select.Option>
                                        </Select>
                                    </Item>
                                    <Item
                                        label={t("自动备份")}
                                        name="autoBackup"
                                        extra={t("按照周期自动备份")}
                                    >
                                        <Select style={{width:"50%"}}>
                                            <Select.Option value={true}>{t("是")}</Select.Option>
                                            <Select.Option value={false}>{t("否")}</Select.Option>
                                        </Select>
                                    </Item>
                                    <Item
                                        label={t("本地快照")}
                                        name="mobileBackups"
                                        extra={t("在未联网时创建本地快照")}
                                    >
                                        <Select style={{width:"50%"}}>
                                            <Select.Option value={true}>{t("启用")}</Select.Option>
                                            <Select.Option value={false}>{t("禁用")}</Select.Option>
                                        </Select>
                                    </Item>
                                    <Item
                                        label={t("备份容量限制")}
                                        name="backupSizeMB"
                                        extra={t("设置备份容量大小，0代表无限制")}
                                    >
                                        <InputNumber addonAfter={"MB"} min={0}></InputNumber>
                                    </Item>
                                    <Form.Item label="备份路径" className="custom-form-spacing">
                                        <Form.List name="basePaths">
                                        {(fields, { add, remove }) => (
                                            <>
                                                {fields.map((field) => (
                                                    <Form.Item key={field.key} >
                                                        <Row justify="space-between">
                                                            <Col span="21">
                                                                <Form.Item 
                                                                    style={{ flex: 1, marginBottom: 0 }}
                                                                    {...field}
                                                                    //name={[field.name]}
                                                                    rules={[{ required: true, message: '不能为空' }]}
                                                                >
                                                                    <Input />
                                                                </Form.Item>
                                                            </Col>
                                                            <Col>
                                                                <Button type="dashed" onClick={() => { remove(field.name) }}>-</Button>
                                                            </Col>
                                                        </Row>
                                                    </Form.Item>
                                                ))}
                                                <Form.Item>
                                                    <Button type="dashed" onClick={() => { add() }} block>
                                                        <PlusOutlined />{t("添加备份路径")}
                                                    </Button>
                                                </Form.Item>
                                            </>
                                        )}
                                        </Form.List>
                                    </Form.Item>
                                    <Form.Item label="不备份路径" className="custom-form-spacing">
                                        <Form.List name="skipPaths">
                                        {(fields, { add, remove }) => (
                                            <>
                                                {fields.map((field) => (
                                                    <Form.Item key={field.key} >
                                                        <Row justify="space-between">
                                                            <Col span="21">
                                                                <Form.Item 
                                                                    style={{ flex: 1, marginBottom: 0 }}
                                                                    {...field}
                                                                    //name={[field.name]}
                                                                    rules={[{ required: true, message: '不能为空' }]}
                                                                >
                                                                    <Input />
                                                                </Form.Item>
                                                            </Col>
                                                            <Col>
                                                                <Button type="dashed" onClick={() => { remove(field.name) }}>-</Button>
                                                            </Col>
                                                        </Row>
                                                    </Form.Item>
                                                ))}
                                                <Form.Item>
                                                    <Button type="dashed" onClick={() => { add() }} block>
                                                        <PlusOutlined />{t("添加不备份路径")}
                                                    </Button>
                                                </Form.Item>
                                            </>
                                        )}
                                        </Form.List>
                                    </Form.Item>
                        </Form>
                        <div style={{ margin: "32px 16px 8px 50px", fontSize: "20px", textAlign: "center", width: "100%" }}>
                            <Button style={{ width: 100 }} type="primary" onClick={() => { addTemplateClick(); }}> {t("保存")} </Button>
                            <Button style={{ width: 100, marginLeft: 20 }} type="primary" ghost onClick={() => { deleteTemplateClick(); }}>{t("删除规则")}</Button>
                        </div>
                    </>
                )}
            </Row>
        </div>

    </>)
};